import Btn, { BtnModifier } from 'components/btn';
import Header, { HeaderModifier } from 'components/header';
import ImportTable from 'components/table/importTable';
import { useNavigate } from 'react-router-dom';
import PlusIcon from 'assets/icons/plus.svg';
import { useTranslation } from 'react-i18next';

function OverviewComponent() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="ct_padding">
      <div className="ct_section _oldView">
        <div className="ct_section-inner">
          <div className="ct_section-main">
            <div className="ct_overviewHeader">
              <div className="ct_overviewHeader-main">
                <Header
                  headline={t('Overview', { ns: 'overview' })}
                  desc={t('This overview provides a list of your current imports grouped by your exchanges/wallets.', { ns: 'overview' })}
                  modifiers={[HeaderModifier.OLD, HeaderModifier.OLD_MARGIN]}
                />
              </div>
              <div className="ct_overviewHeader-aside">
                <Btn onClick={() => navigate('/import')} icon={<PlusIcon />} type="primary" text={t('Add Import', { ns: 'overview' })} modifier={[BtnModifier.OLD]} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="ct_section _oldView">
        <div className="ct_section-inner">
          <div className="ct_overviewHeader-anchor _old">
            <ImportTable 
              onLoadCb={() => {}}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default OverviewComponent;
